<template>
  <div class="move-text-wrapper position-relative overflow-hidden bg_secondary">
    <ul class="move-text style-one d-flex align-items-center list-unstyled mb-0">
      <li
        v-for="(item, index) in practiceAreas"
        :key="index"
        class="d-inline-block position-relative fs-24 fw-medium text-white"
      >
        {{ item }}
      </li>
    </ul>
  </div>
</template>

<script>
export default {
    name: 'MoveTextWrapper',
    data() {
        return {
            practiceAreas: []
        }
    },
    async mounted() {
        await this.loadPracticeAreas()
    },
    methods: {
        async loadPracticeAreas() {
            try {
                // Try to load from services/practice areas
                const response = await this.$api.get('public/content/services')
                if (response.data && response.data.data) {
                    // Extract titles and duplicate for smooth scrolling
                    const areas = response.data.data.map(item => item.title || item.name)
                    this.practiceAreas = [...areas, ...areas] // Duplicate for seamless loop
                }
            } catch (error) {
                console.error('Failed to load practice areas:', error)
            }
            
            // Fallback to default areas if none loaded
            if (this.practiceAreas.length === 0) {
                const defaultAreas = [
                    'Great Stuff',
                    'Education',
                    'Great Facilities',
                    'Professional Care',
                    'Modern Equipment',
                    'Expert Team'
                ]
                this.practiceAreas = [...defaultAreas, ...defaultAreas] // Duplicate for seamless loop
            }
        }
    }
}
</script>

<style scoped>
.move-text-wrapper {
    padding: 25px 0;
}

.move-text {
    animation: moveText 30s linear infinite;
    white-space: nowrap;
}

.move-text li {
    margin-right: 60px;
}

.move-text li:after {
    content: '*';
    position: absolute;
    right: -35px;
    top: 50%;
    transform: translateY(-50%);
}

@keyframes moveText {
    0% {
        transform: translateX(0);
    }
    100% {
        transform: translateX(-50%);
    }
}

@media (max-width: 991px) {
    .move-text li {
        font-size: 20px !important;
        margin-right: 40px;
    }
    
    .move-text li:after {
        right: -25px;
    }
}
</style>

